import request from '@/lib/request/'

const baseUri = 'art_banner/'

/**
 * @returns {Promise}
 */
export function getDetail () {
  return request({
    url: baseUri,
    method: 'get'
  })
}

/**
 * @param data {Object} form data
 * @returns {Promise}
 */
export function post (data) {
  return request({
    url: baseUri,
    method: 'post',
    data
  })
}

/**
 * @param data {Object} form data
 * @returns {Promise}
 */
export function put (data) {
  return request({
    url: baseUri,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/art_banner/index.js